import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import APIEndPoints from '../../../../middleware/APIEndPoints';


const ProjectVideo = () => {

  const { projectId } = useParams(); // Get the project ID from URL
  const [videos, setVideos] = useState([]); // State to store fetched images
  const [videoData, setVideoData] = useState({
    title: '',
    videoFile: null
  });
  const [videoPreview, setVideoPreview] = useState(null); // For previewing the image before upload

  const baseURL = APIEndPoints.myprojects.url;
  const cloudName = process.env.REACT_APP_CLOUD_NAME;
  const uploadPreset = 'videos_presets'; // Cloudinary upload preset

  // Fetch project videos when the component loads
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(`${baseURL}/${projectId}/videos`);
        setVideos(response.data); // Set the videos in state
      } catch (error) {
        console.error('Error fetching videos:', error);
      }
    };

    fetchVideos();
  }, [projectId]);

  // Handle file and input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setVideoData({ ...videoData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const maxSize = 100 * 1024 * 1024; // 100MB limit

    if (file.size > maxSize) {
      alert('The file size exceeds the limit of 100MB. Please upload a smaller file.');
      setVideoData({ ...videoData, videoFile: null });
      return;
    }

    setVideoData({ ...videoData, videoFile: file });
    const previewURL = URL.createObjectURL(file);
    setVideoPreview(previewURL);
  };


  // Function to upload video to Cloudinary
  const handleUpload = async () => {
    const formData = new FormData();
    formData.append('file', videoData.videoFile);
    formData.append('upload_preset', uploadPreset);

    try {
      // Upload video to Cloudinary
      const response = await axios.post(
        `https://api.cloudinary.com/v1_1/${cloudName}/video/upload`,
        formData
      );
      return response.data.secure_url; // Return the uploaded image URL
    } catch (error) {
      console.error('Error uploading image:', error);
      return null;
    }
  };

  // Handle video submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!videoData.videoFile) {
      alert('Please select an video to upload.');
      return;
    }

    // Upload video to Cloudinary
    const videoUrl = await handleUpload();
    if (!videoUrl) {
      alert('Failed to upload video.');
      return;
    }

    try {
      // Send video URL and title to the backend
      const response = await axios.post(`${baseURL}/${projectId}/videos`, {
        title: videoData.title,
        url: videoUrl
      });

      // Update the videos array
      setVideos([...videos, response.data]);
      setVideoData({ title: '', videoFile: null }); // Reset the form
      setVideoPreview(null); // Clear video preview
      console.log("Successfully added the video");
    } catch (error) {
      console.error('Error uploading video:', error);
    }
  };


  // Handle video deletion
  const handleDelete = async (videoId) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this image?');
    if (!confirmDelete) return;

    try {
      // Send a delete request to the backend
      await axios.delete(`${baseURL}/${projectId}/videos/${videoId}`);
      // Update the video array by removing the deleted video
      setVideos(videos.filter((video) => video._id !== videoId));
      console.log("Successfully deleted the video");
    } catch (error) {
      console.error('Error deleting video:', error);
    }
  };
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Manage Project Videos</h2>

      {/* Video input fields outside of the form */}
      <div className="mb-6">
        <div className="mb-4">
          <label htmlFor="title" className="block text-white">Video Title:</label>
          <input
            type="text"
            id="title"
            name="title"
            value={videoData.title}
            onChange={handleInputChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="videoFile" className="block text-white">Upload Video:</label>
          <input
            type="file"
            id="videoFile"
            name="videoFile"
            accept="video/*"
            onChange={handleFileChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
        </div>

        {/* Video Preview */}
        {videoPreview && (
          <div className="mb-4">
            <h3 className="text-white">Video Preview:</h3>
            <video src={videoPreview} controls className="w-full h-auto rounded mt-2" />
          </div>
        )}

        <button onClick={handleSubmit} className="bg-blue-600 px-4 py-2 rounded text-white hover:bg-blue-700">
          Upload Video
        </button>
      </div>

      {/* Display all uploaded videos */}
      <h3 className="text-xl font-bold mb-4">Existing Videos</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {videos.length > 0 ? (
          videos.map((video, index) => (
            <div key={video._id || index} className="bg-gray-800 p-4 rounded-lg">
              <video src={video.url} controls className="w-full h-auto rounded" />
              <p className="text-white mt-2">{video.title}</p>
              <button
                onClick={() => handleDelete(video._id)}
                className="bg-red-600 px-2 py-1 rounded text-white hover:bg-red-700 mt-2"
              >
                Delete
              </button>
            </div>
          ))
        ) : (
          <p className="text-white">No videos uploaded for this project yet.</p>
        )}
      </div>
    </div>
  )
}

export default ProjectVideo
